/**
 * This file is for all the constants that will be used for the mutations and getters that is used in Vuex.
 * This is to streamline all the names so that if there are any changes in the string, it will be reflected throughout.
 */

export const VUEX_GENERAL = {
  GETTERS: {
    getCurrentPolicyNumber: 'getCurrentPolicyNumber',
    getLogoutState: 'getLogoutState',
    memberships: 'memberships',
    getCurrentMemberDetails: 'getCurrentMemberDetails',
    getCurrentPersonCode: 'getCurrentPersonCode',
    getCurrentMembership: 'getCurrentMembership',
    getCurrentPolicyIsExtrasFlag: 'getCurrentPolicyIsExtrasFlag',
    getCurrentPolicyExtrasOnlyFlag: 'getCurrentPolicyExtrasOnlyFlag',
    getMembershipInfo: 'getMembershipInfo',
    getMembers: 'getMembers',
    getAccessLevel: 'getAccessLevel',
  },
  MUTATIONS: {
    updateCurrentMemberDetails: 'updateCurrentMemberDetails',
    updateLogout: 'updateLogout',
    saveThisPolicyNumber: 'saveThisPolicyNumber',
    resetPolicy: 'resetPolicy',
    saveThisMembership: 'saveThisMembership',
    updateMembershipInfo: 'updateMembershipInfo',
    updateMembers: 'updateMembers',
  },
  ACTIONS: {
    getCoveredAs: 'getCoveredAs',
  },
};

export const VUEX_MEMBER_DETAILS = {
  GETTERS: {
    getMemberDetailsFormValidationStatus: 'getMemberDetailsFormValidationStatus',
    getMemberDetailsPageReferenceData: 'getMemberDetailsPageReferenceData',
    getMemberDetails: 'getMemberDetails',
    getMemberDetailsPageNum: 'getMemberDetailsPageNum',
    getHasFormBeenUpdated: 'getHasFormBeenUpdated',
    getSubmitUpdateSuccessfulStatus: 'getSubmitUpdateSuccessfulStatus',
    getCoverDetails: 'getCoverDetails',
    getSubmitPolicyInProcess: 'getSubmitPolicyInProcess',
    getMemberPolicies: 'getMemberPolicies',
  },
  MUTATIONS: {
    resetMemberDetails: 'resetMemberDetails',
    updateMemberDetailsRefData: 'updateMemberDetailsRefData',
    updateMemberDetails: 'updateMemberDetails',
    updateMemberDetailsPageNum: 'updateMemberDetailsPageNum',
    updateMemberDetailsFormValid: 'updateMemberDetailsFormValid',
    updateHasFormBeenUpdated: 'updateHasFormBeenUpdated',
    updateSubmitUpdateSuccessful: 'updateSubmitUpdateSuccessful',
    updateCoverDetails: 'updateCoverDetails',
    updateSubmitPolicyInProcess: 'updateSubmitPolicyInProcess',
    updateMemberPolicies: 'updateMemberPolicies',
  },
};

export const VUEX_BENEFIT_QUOTES_CLAIMS = {
  GETTERS: {
    getRefData: 'getRefData',
    getFormResponse: 'getFormResponse',
    getCurrentPage: 'getCurrentPage',
    getFormResponseStepsInvalid: 'getFormResponseStepsInvalid',
    getSelectedProviderFlexCode: 'getSelectedProviderFlexCode',
    getFileUploadStatus: 'getFileUploadStatus',
    getFileRemovedStatus: 'getFileRemovedStatus',
    getMappedQuoteProductCodes: 'getMappedQuoteProductCodes',
  },
  MUTATIONS: {
    resetFormResponses: 'resetFormResponses',
    resetState: 'resetState',
    resetRefGeneral: 'resetRefGeneral',
    updateCurrentPage: 'updateCurrentPage',
    updateRefGeneral: 'updateRefGeneral',
    updateRefMemberNumber: 'updateRefMemberNumber',
    updateRefMembers: 'updateRefMembers',
    updateRefProducts: 'updateRefProducts',
    updateRefProviders: 'updateRefProviders',
    updateRefServices: 'updateRefServices',
    updateRefAccounts: 'updateRefAccounts',
    updateFormResponse: 'updateFormResponse',
    updateFormResponseStepsInvalid: 'updateFormResponseStepsInvalid',
    updateFileUpload: 'updateFileUpload',
    updateFileRemoved: 'updateFileRemoved',
    updateMappedQuoteProductCodes: 'updateMappedQuoteProductCodes',
  },
};

export const VUEX_TAX_STATEMENTS = {
  GETTERS: {
    getRefData: 'getRefData',
    getTaxStatements: 'getTaxStatements',
    getTaxStatementDocument: 'getTaxStatementDocument',
  },
  MUTATIONS: {
    resetState: 'resetState',
  },
};

export const VUEX_PAYMENTS = {
  GETTERS: {
    getRefData: 'getRefData',
    getPayments: 'getPayments',
  },
  MUTATIONS: {
    resetState: 'resetState',
  },
};

export const VUEX_GENERATE_MEMBER_CARD = {
  GETTERS: {
    getNumberOfCards: 'getNumberOfCards',
    getPostalAddress: 'getPostalAddress',
    getRecentOrder: 'getRecentOrder',
    getCurrentPage: 'getCurrentPage',
  },
  MUTATIONS: {
    resetState: 'resetState',
    updateNumberOfCards: 'updateNumberOfCards',
    updatePostalAddress: 'updatePostalAddress',
    updateRecentOrder: 'updateRecentOrder',
    updateCurrentPage: 'updateCurrentPage',
  },
};

export const VUEX_REBATE_NOMINATION = {
  GETTERS: {
    getCurrentPage: 'getCurrentPage',
    getRefData: 'getRefData',
    getUpdateRebateTier: 'getUpdateRebateTier',
  },
  MUTATIONS: {
    resetState: 'resetState',
    updateCurrentPage: 'updateCurrentPage',
    updateFeature: 'updateFeature',
    updateRefCanUpdate: 'updateRefCanUpdate',
    updateRefComposition: 'updateRefComposition',
    updateRefCurrentTier: 'updateRefCurrentTier',
    updateRefRebateTierOptions: 'updateRefRebateTierOptions',
  },
};

export const VUEX_MAKE_A_PAMENT = {
  GETTERS: {
    getCurrentStep: 'getCurrentStep',
    getPaymentAmount: 'getPaymentAmount',
    getHasNominatedCard: 'getHasNominatedCard',
  },
  MUTATIONS: {
    resetStore: 'resetAll',
    updatePaymentAmount: 'updatePaymentAmount',
    updateCurrentStep: 'updateCurrentStep',
    updateHasNominatedCard: 'updateHasNominatedCard',
  },
};

export const VUEX_PAYMENT_DETAILS = {
  GETTERS: {
    getPaymentDetailsPageReferenceData: 'getPaymentDetailsPageReferenceData',
    getPaymentDetails: 'getPaymentDetails',
    getPaymentDetailsFormValidationStatus: 'getPaymentDetailsFormValidationStatus',
    getPaymentDetailsPageNum: 'getPaymentDetailsPageNum',
    getHasFormBeenUpdated: 'getHasFormBeenUpdated',
    getSubmitUpdateSuccessfulStatus: 'getSubmitUpdateSuccessfulStatus',
    getSubmitPolicyInProcess: 'getSubmitPolicyInProcess',
  },
  MUTATIONS: {
    resetPaymentDetails: 'resetPaymentDetails',
    updatePaymentDetailsInfo: 'updatePaymentDetailsInfo',
    updatePaymentDetailsPageNum: 'updatePaymentDetailsPageNum',
    updatePaymentDetailsFormValid: 'updatePaymentDetailsFormValid',
    updatePaymentDetailsRefData: 'updatePaymentDetailsRefData',
    updateHasFormBeenUpdated: 'updateHasFormBeenUpdated',
    updateSubmitUpdateSuccessful: 'updateSubmitUpdateSuccessful',
    updateSubmitPolicyInProcess: 'updateSubmitPolicyInProcess',
  },
};

export const VUEX_WAITING_PERIODS = {
  GETTERS: {
    getMemberList: 'getMemberList',
    getWaitingPeriods: 'getWaitingPeriods',
  },
  MUTATIONS: {
    updateMembersList: 'updateMembersList',
    updateWaitingPeriods: 'updateWaitingPeriods',
  },
};

export const VUEX_LIMITS_AND_USAGE = {
  GETTERS: {
    getMemberHistory: 'getMemberHistory',
  },
  MUTATIONS: {
    resetLimitsAndUsage: 'resetLimitsAndUsage',
    updateMemberHistory: 'updateMemberHistory',
  },
};

export const VUEX_CHANGE_COVER = {
  GETTERS: {
    getAllMembers: 'getAllMembers',
    getCurrentComposition: 'getCurrentComposition',
    getCurrentEligibility: 'getCurrentEligibility',
    getPartnerData: 'getPartnerData',
    getChildrenData: 'getChildrenData',
    getMembershipPolicies: 'getMembershipPolicies',
    getMembershipDetails: 'getMembershipDetails',
    getEligibilityDetails: 'getEligibilityDetails',
    getReferenceData: 'getReferenceData',
    getSubmitPolicyInProcess: 'getSubmitPolicyInProcess',
  },
  MUTATIONS: {
    updateAllMembersDetails: 'updateAllMembersDetails',
    updatePartnerData: 'updatePartnerData',
    updateCurrentComposition: 'updateCurrentComposition',
    updateCurrentEligibility: 'updateCurrentEligibility',
    updateChildrenData: 'updateChildrenData',
    updateMembershipPolicies: 'updateMembershipPolicies',
    updateMembershipDetails: 'updateMembershipDetails',
    updateEligibilityDetails: 'updateEligibilityDetails',
    updateReferenceData: 'updateReferenceData',
    resetAddRemoveVuexStore: 'resetAddRemoveVuexStore',
    updateSubmitPolicyInProcess: 'updateSubmitPolicyInProcess',
  },
};

export const VUEX_CHANGE_EXCESS = {
  GETTERS: {
    getComposition: 'getComposition',
    getEligibility: 'getEligibility',
    getCurrentExcess: 'getCurrentExcess',
    getExcessType: 'getExcessType',
    getNewExcess: 'getNewExcess',
    getExcessOptions: 'getExcessOptions',
    getCurrentPremiumAndFrequency: 'getCurrentPremiumAndFrequency',
    getNewPremiumAndFrequency: 'getNewPremiumAndFrequency',
    getCurrentPage: 'getCurrentPage',
    getSubmitPolicyInProcess: 'getSubmitPolicyInProcess',
  },
  MUTATIONS: {
    updateComposition: 'updateComposition',
    updateEligibility: 'updateEligibility',
    updateCurrentExcess: 'updateCurrentExcess',
    updateExcessType: 'updateExcessType',
    updateNewExcess: 'updateNewExcess',
    updateExcessOptions: 'updateExcessOptions',
    updateCurrentPremiumAndFrequency: 'updateCurrentPremiumAndFrequency',
    updateNewPremiumAndFrequency: 'updateNewPremiumAndFrequency',
    updateCurrentPage: 'updateCurrentPage',
    updateSubmitPolicyInProcess: 'updateSubmitPolicyInProcess',
  },
};

export const VUEX_REBATES = {
  GETTERS: {
    getRebateHistory: 'getRebateHistory',
    getMembershipDetails: 'getMembershipDetails',
    getSubmitPolicyInProcess: 'getSubmitPolicyInProcess',
  },
  MUTATIONS: {
    updateRebateHistory: 'updateRebateHistory',
    updateMembershipDetails: 'updateMembershipDetails',
    updateSubmitPolicyInProcess: 'updateSubmitPolicyInProcess',
  },
};
